import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';
import { ColorPicker } from '../../../../shared/ColorPicker/ColorPicker.jsx';

const popoverStyle = css`
  right: 20px;
  top: 70px;
`;

const swatchStyle = css`
  background: ${themeGet('colors.white')};
  border-radius: 8px;
  width: 100%;
  padding: 8px;
  position: absolute;
  top: 25px;
  right: 20px;
  height: 40px;
  width: fit-content;
  z-index: 1;
  cursor: pointer;
`;

export const ColorInput = ({ color, setColor }) => {
  const { t } = useTranslation('campaigns');

  return (
    <ColorPicker
      colorChangeHandler={newColor => setColor(newColor)}
      width="16px"
      height="16px"
      initialColor={color}
      key={color}
      popoverStyle={popoverStyle}
      swatchStyle={swatchStyle}
      title={t('banner.colorTooltip')}
    >
      <Text color="black.100" variant="small1">
        {t('banner.colorInputLabel')}
      </Text>
    </ColorPicker>
  );
};
